"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sliceKey = exports.reducer = exports.resultsProviderActions = exports.initialState = void 0;
const api_1 = require("../../utils/api");
const toolkit_1 = require("../../utils/@reduxjs/toolkit");
const slices_1 = require("../../utils/@reduxjs/slices");
const utils_1 = require("../ConfigProvider/utils");
const types_1 = require("../ConfigProvider/types");
const utils_2 = require("./utils");
const REDUCER_KEY = 'resultsProvider';
exports.initialState = {
    data: {
        resultsBySportAndTournament: {},
        fetchItems: api_1.requestInitialState,
        resultCountersBySport: {},
        fetchCountersItems: api_1.requestInitialState,
        linkedEvents: {},
        eventResults: {},
        fetchItem: api_1.requestInitialState,
        pagination: {
            paginationKey: '',
            paginationLoading: false,
            hasMore: true,
        },
    },
    filters: {
        currentSportId: 100,
        championshipId: null,
        date: new Date(),
        isByLiveResults: false,
        inputSearch: '',
        expandedEventsStat: [],
        expandedTournamentsStat: [],
    },
};
const resultsStateSlice = (0, toolkit_1.createSlice)({
    name: REDUCER_KEY,
    initialState: exports.initialState,
    reducers: {
        fetchResults(state, action) {
            const isNewResultsEndpoint = (0, utils_1.isFeatureFlagEnabled)(types_1.EFeatureFlags.NEW_RESULTS_ENDPOINT);
            const { reqData } = action.payload;
            if (reqData) {
                const { pageKey } = reqData;
                if (isNewResultsEndpoint) {
                    state.data.fetchItems.loading = !pageKey;
                    state.data.pagination.paginationLoading = !!pageKey;
                }
                else {
                    state.data.fetchItems.loading = true;
                }
            }
            state.data.fetchItems.error = null;
        },
        fetchResultsBySports(state, _) {
            state.data.fetchItems.loading = true;
            state.data.fetchItems.error = null;
        },
        fetchLinkedEvents(_state, _action) { },
        fetchLinkedEventsSuccess(state, { payload }) {
            state.data.linkedEvents = {
                ...state.data.linkedEvents,
                ...(0, slices_1.toIdsMap)(payload.items),
            };
        },
        fetchResultsSuccess(state, { payload }) {
            const isNewResultsEndpoint = (0, utils_1.isFeatureFlagEnabled)(types_1.EFeatureFlags.NEW_RESULTS_ENDPOINT);
            if (isNewResultsEndpoint) {
                const { paginationKey, paginationFetch, groupedResults } = payload;
                if (!paginationFetch) {
                    state.data.resultsBySportAndTournament = groupedResults;
                }
                else {
                    Object.keys(groupedResults).forEach((sportId) => {
                        if (!state.data.resultsBySportAndTournament[sportId]) {
                            state.data.resultsBySportAndTournament[sportId] = {};
                        }
                        const tournaments = groupedResults[sportId];
                        if (!tournaments || Object.keys(tournaments).length === 0) {
                            return;
                        }
                        Object.keys(tournaments).forEach((tournamentId) => {
                            var _a, _b;
                            const existingTournament = (_a = state.data.resultsBySportAndTournament[sportId]) === null || _a === void 0 ? void 0 : _a[tournamentId];
                            const tournamentData = groupedResults[sportId][tournamentId].tournament;
                            const existingEvents = (existingTournament === null || existingTournament === void 0 ? void 0 : existingTournament.events) || [];
                            const newEvents = ((_b = groupedResults[sportId][tournamentId]) === null || _b === void 0 ? void 0 : _b.events) || [];
                            if (existingEvents.length === 0 && newEvents.length === 0) {
                                return;
                            }
                            state.data.resultsBySportAndTournament[sportId][tournamentId] = {
                                tournament: tournamentData,
                                events: [...existingEvents, ...newEvents],
                            };
                        });
                    });
                }
                (0, utils_2.expandTournamentsAndEventsState)(state);
                state.data.pagination.hasMore = paginationKey !== null;
                state.data.pagination.paginationKey = paginationKey;
                state.data.fetchItems.loading = false;
                state.data.pagination.paginationLoading = false;
            }
            else {
                if (payload.groupedResults &&
                    Object.keys(payload.groupedResults).length > 0) {
                    state.data.resultsBySportAndTournament = payload.groupedResults;
                    (0, utils_2.expandTournamentsAndEventsState)(state);
                }
                else {
                    state.data.resultsBySportAndTournament = {};
                }
                state.data.fetchItems.loading = false;
                state.data.fetchItems.error = null;
            }
        },
        fetchResultsError(state, { payload }) {
            state.data.fetchItems.loading = false;
            state.data.pagination.paginationLoading = false;
            state.data.fetchItems.error = payload;
        },
        fetchResultCounters(state, _action) {
            state.data.fetchCountersItems.loading = true;
            state.data.fetchCountersItems.error = null;
        },
        fetchResultCountersSuccess(state, { payload }) {
            const resultCountersBySport = (0, slices_1.toIdsMap)(payload.items);
            state.data.resultCountersBySport = resultCountersBySport;
            state.data.fetchCountersItems.loading = false;
            state.data.fetchCountersItems.error = null;
        },
        fetchResultCountersError(state, { payload }) {
            state.data.fetchCountersItems.loading = false;
            state.data.fetchCountersItems.error = payload;
        },
        fetchEventResults(state, _action) {
            state.data.fetchItem.loading = true;
            state.data.fetchItem.error = null;
        },
        fetchEventResultsSuccess(state) {
            state.data.fetchItem.loading = false;
            state.data.fetchItem.error = null;
        },
        updateEventResults(state, { payload }) {
            state.data.eventResults = {
                ...state.data.eventResults,
                ...(0, slices_1.toIdsMap)(payload.eventResults),
            };
        },
        fetchEventResultsError(state, { payload }) {
            state.data.fetchItem.loading = false;
            state.data.fetchItem.error = payload;
        },
        setChampionshipFilter(state, { payload }) {
            state.filters.championshipId = payload.championshipId;
        },
        setCurrentSportIdFilter(state, { payload, }) {
            state.data.fetchItems.loading = true;
            state.data.fetchItems.error = null;
            state.filters.championshipId = null;
            state.filters.inputSearch = '';
            state.filters.currentSportId = payload.sportId;
        },
        setDateFilter(state, { payload }) {
            state.filters.championshipId = null;
            state.data.fetchItems.loading = true;
            state.filters.date = payload.date;
        },
        toggleIsLiveEventsFilter(state) {
            state.filters.isByLiveResults = !state.filters.isByLiveResults;
        },
        toggleExpandedEventStatFilter(state, { payload }) {
            const isExpandedEvent = state.filters.expandedEventsStat.includes(payload.id);
            if (isExpandedEvent) {
                state.filters.expandedEventsStat =
                    state.filters.expandedEventsStat.filter((eventId) => eventId !== payload.id);
            }
            else {
                state.filters.expandedEventsStat.push(payload.id);
            }
        },
        toggleExpandedTournamentStatFilter(state, { payload }) {
            const isExpandedTournament = state.filters.expandedTournamentsStat.includes(payload.id);
            if (isExpandedTournament) {
                state.filters.expandedTournamentsStat =
                    state.filters.expandedTournamentsStat.filter((tournamentId) => tournamentId !== payload.id);
            }
            else {
                state.filters.expandedTournamentsStat.push(payload.id);
            }
        },
        toggleAllExpandedEventStatFilter(state) {
            const expandedEventsStatLength = state.filters.expandedEventsStat.length;
            const expandedTournamentsStatLength = state.filters.expandedTournamentsStat.length;
            if (expandedEventsStatLength || expandedTournamentsStatLength) {
                state.filters.expandedEventsStat = [];
                state.filters.expandedTournamentsStat = [];
            }
            else {
                (0, utils_2.expandTournamentsAndEventsState)(state);
            }
        },
        setSearchResultsFilter(state, { payload }) {
            state.filters.inputSearch = payload.text;
        },
        resetDatePickerRangeValues(state) {
            state.filters.date = new Date();
        },
    },
});
exports.resultsProviderActions = resultsStateSlice.actions, exports.reducer = resultsStateSlice.reducer, exports.sliceKey = resultsStateSlice.name;
//# sourceMappingURL=slice.js.map